<template>
  <v-card>
    <v-toolbar dark color="blue darken-3">
      <v-toolbar-title>식당 추가하기</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex xs12>
            <v-text-field prepend-icon="restaurant" :rules="restaurantNameRules" label="식당 이름" v-model="restaurantName"
              required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-select :items="restaurantSectors" label="식단 대상" @change="setSelect"></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field prepend-icon="lock" label="입장 비밀번호(없어도됨)" v-model="restaurantPassword"
              type="current-password"></v-text-field>
          </v-flex>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey--text text--darken-1" @click="close">취소</v-btn>
        <v-btn color="blue darken-3" dark @click="addRestaurant">만들기</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { ApiService } from "@/services/GuneApiService.js";
import RestaurantSector from "@/utils/RestaurantSector.js";

export default {
  data: () => ({
    valid: true,
    restaurantName: "",
    restaurantNameRules: [v => !!v || "식당명 필요합니다"],
    restaurantPassword: "",
    restaurantSectors: RestaurantSector.getSector(),
    restaurantSector: ""
  }),
  props: {
    dialog: Boolean
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.$emit("update:dialog", false);
    },
    setSelect(sector) {
      this.restaurantSector = sector;
    },
    addRestaurant() {
      if (this.restaurantName === undefined) return alert("이름이 없습니다");
        
      ApiService()
        .post("/gune", {
          nm: this.restaurantName,
          pw: this.restaurantPassword,
          grp: this.restaurantSector
        })
        .then(res => {
          alert("생성완료" + res.data);
          this.$store.dispatch("getRestaurants");
          this.$emit("update:dialog", false);
          this.$refs.form.reset();
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.error("Server Error:", err.response ? err.response.data : err);
          alert(

            err.response ? err.response.data : err
          );
        });
    }
  }
};
</script>